import React, { Component } from 'react'
import HttpServices from '../../../utils/Http.services'
import CustomLoader from '../../CustomLoader'
import FixedView from '../../FixedView'
import { checkTranslation, imageAddress, translate } from '../../../utils/useful'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import * as actions from '../../../stores/actionsList';

class MessengerSelectMyRef extends Component {

    state = {
        permissions: [
            { title: "{{lang}}messenger.Send Messages" },
            { title: "{{lang}}messenger.Send Media" },
            { title: "{{lang}}messenger.Add Members" },
            { title: "{{lang}}messenger.Create Topics" },
            { title: "{{lang}}messenger.Pin Messages" },
            { title: "{{lang}}messenger.change Group info" },
        ],
        topic: "",
        isLoader: false,
    }

    createTopic = (messenger) => {
        let users = []
        let data = {}
        this.setState({ isLoader: true })
        if (this.form1) {
            users = this.form1.getForm()
            data.users = users
        }
        data.topic = this.state.topic
        data.messenger = messenger
        HttpServices.request('createTopic', data, (fetchResult, fetchError) => {

            this.setState({ isLoader: false })
        })
    }

    openFirstView = () => {
        this.firstView.showView()
    }

    changeValue = (key, value) => {
        this.setState({ [key]: value })
    }

    setMyActiveRef = (item) => {
        this.props.setMyActiveRef(item)
        setTimeout(() => {
            this.firstView.hideView()
        }, 50);

    }

    render() {

        return (
            <div className='h-100' ref={el => this.firstCurrentNode = el}>
                <button className="mld-1 flexcc" onClick={() => this.openFirstView()}>
                    {this.props.myActiveRef ? (
                        <img className='br-30' src={imageAddress(this.props.myActiveRef?.hub?.image, 'hub', 'mini')} style={{ transition: '0.3s all', objectFit: 'cover' }} height={22} width={22} alt='' />
                    ) : (
                        <div className='flexc'>
                            <img className='br-30 mrd-2' src={'/images/profile-men-1.svg'} style={{ transition: '0.3s all', objectFit: 'cover' }} height={22} width={22} alt=''/>
                            <p className='text-semibold'>{translate("Select on behalf frame first")}</p>
                        </div>
                    )}
                </button>
                <FixedView ref={el => this.firstView = el} nodeRef={this.firstCurrentNode} showFocus={false} topOffset={10} bottomOffset={36} xOffset={-10} zIndex={10} >
                    {!this.state.isLoader ? (
                        <div className='white-bg shadow-3 br-10 pt-1 px-1' style={{ width: 220, }}>
                            <div className='d-flex flex-column w-100'>

                                <p className='font-size-14 text-bold  mx-1 mt-1'>{translate("Send message as")}</p>
                                <p className='font-size-11 pb-1 mx-1' style={{ borderBottom: '1px solid #eee' }}>{translate("You can send messages on behalf of one of the following hubs and frames.")}</p>

                                {this.props.myValidRefs?.map((item, index) => {
                                    return (
                                        <div className='w-100 flexcb  mb-1 px-1 py-1 br-5 hover-gray2' style={{ cursor: 'pointer', borderBottom: '0px solid #eee' }} onClick={() => this.setMyActiveRef(item)}>
                                            <button className='text-start  ' >
                                                <div className=' w-100 flexc'>
                                                    <div className='flexcc'>
                                                        <img className='mrd-1 br-20 mrd-2' src={imageAddress(item.hub?.image, 'hub', 'mini')} alt='' height={20} width={20} />
                                                    </div>
                                                    <div className='flex-1' style={{ minWidth: 0 }}>
                                                        <p className='font-size-13 text-semibold'>{item.hub?.fullname}</p>
                                                        <p className='font-size-11 color-gray-1 w-100' style={{ textOverflow: 'ellipsis', overflow: 'hidden', }}>{checkTranslation(item.frame?.name)} - {checkTranslation(item.applet?.name)}</p>
                                                    </div>
                                                </div>
                                            </button>

                                        </div>
                                    )
                                })}
                            </div>

                        </div>
                    ) : (
                        <div className='h-100 flexcc'>
                            <CustomLoader color={"#007aff"} isLoading={true} />
                        </div>
                    )
                    }
                </FixedView>
            </div >
        )
    }
}

const mapStateToProps = state => ({ settings: state.settings, user: state.user, messengers: state.messengers })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(MessengerSelectMyRef);